import React from 'react';
import Image from 'components/common/ImageLoader';
import SuccessIcon from 'assets/toast_success.svg';
import ErrorIcon from 'assets/toast_error.svg';

const CustomToast = (props) => {
  const selectIconToRender = () => {
    switch (props.toastType) {
      case 'success':
        return SuccessIcon;
      case 'error':
        return ErrorIcon;
      default:
        return SuccessIcon;
    }
  };

  const selectBg = () => {
    switch (props.toastType) {
      case 'success':
        return 'bg-success-active ';
      case 'error':
        return 'bg-danger-active';
      default:
        return 'bg-success-active';
    }
  };

  const icon = selectIconToRender();
  const bgFill = selectBg();
  return (
    <div className={`flex items-center text-white px-4 py-4 ${bgFill}`}>
      <img width="25" height="25" src={icon} />
      <span className="pl-2 font-bold">{props.message}</span>
    </div>
  );
};

export default CustomToast;
